import AppDispatcher from "../Dispatcher";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import { fetchWithAuthGet } from "../FetchWithAuth";

const apiBasePath = AppConfig.getBookApiBasePath();

const hostName = window.location.origin;
const basePath = hostName.includes("https://dev-")
	? "https://dev-admin-api.cloud.vivaki.com/"
	: hostName.includes("https://demo-")
		? "https://demo-taxonomy-api.publicismedia.com/"
		: hostName.includes("localhost")
			? "https://dev-admin-api.cloud.vivaki.com/"
			: hostName.includes("https://qa-")
				? "https://qa-admin-api.publicismedia.com/"
				: hostName.includes("https://preprod-")
					? "https://preprod-admin-api.publicismedia.com/"
					: "https://api-taxonomy.publicismedia.com/";

export const fetchAllSideNav = (userid, success) => {
	const requests = [];
	requests.push(fetchWithAuthGet(`${apiBasePath.ApiBasePath}/userAuth/GetUserRoles?userid=${userid}&applicationName=Campaign Framework - Apollo`));
	requests.push(fetchWithAuthGet(`${apiBasePath.ApiBasePath}/userAuth/GetUserRoles?userid=${userid}&applicationName=Taxonomy Config`));
	requests.push(fetchWithAuthGet(`${apiBasePath.ApiBasePath}/userAuth/GetUserRoles?userid=${userid}&applicationName=Creative Framework`));
	Promise.all(requests).then((permissions) => {
		const listApps = permissions?.map((permArray) => permArray?.[0]) || [];
		success?.(listApps);
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchSideNav,
			value: listApps
		});
	});
};

export const fetchUserRole = (contextID) => {
	fetchWithAuthGet(`${apiBasePath.ApiBasePath}/plook/campaign/GetUserInfo/${contextID}`).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.getUserRole,
			value: response?.[0]
		});
	});
};
